import React, { useMemo } from 'react'
import Modal from '../../components/modal'
import useI18n from '../../i18n/useI18n'
import general from '../../utils/general'

const AgentInfoModal = ({ isOpen, agent, agentName, onClose }) => {
  const { t } = useI18n()
  const agentEntity = agent || {}

  const displayName = useMemo(() => {
    if (agentName && agentName.trim()) return agentName.trim()
    if (agentEntity.companyName) return agentEntity.companyName
    if (agentEntity.name) return agentEntity.name
    if (agentEntity.fullName) return agentEntity.fullName

    const firstName = agentEntity.firstName || agentEntity?.user?.firstName || ''
    const lastName = agentEntity.lastName || agentEntity?.user?.lastName || ''
    const combined = `${firstName} ${lastName}`.trim()
    if (combined) return combined

    return agentEntity.email || agentEntity?.user?.email || ''
  }, [agentEntity, agentName])

  const logoUrl = useMemo(() => {
    if (!agentEntity) return ''
    return agentEntity.logoUrl || agentEntity.logoURL || agentEntity.logo
  }, [agentEntity])

  const renderInfo = (label, value, icon) => {
    const displayValue = value === null || value === undefined || value === '' ? '-' : value

    return (
      <div className="m-b-15 d-flex">
        {icon && <i className={`zmdi ${icon} m-r-10 text-warning`} style={{ fontSize: '18px' }}></i>}
        <div>
          <small className="text-muted d-block">{label}</small>
          <strong>{displayValue}</strong>
        </div>
      </div>
    )
  }

  const renderLink = (label, url, icon) => {
    const hasUrl = typeof url === 'string' && url.trim()

    return (
      <div className="m-b-15 d-flex">
        {icon && <i className={`zmdi ${icon} m-r-10 text-warning`} style={{ fontSize: '18px' }}></i>}
        <div>
          <small className="text-muted d-block">{label}</small>
          {hasUrl ? (
            <a href={url} target="_blank" rel="noreferrer">
              {url}
            </a>
          ) : (
            <strong>-</strong>
          )}
        </div>
      </div>
    )
  }

  if (!agent && !agentName) return null

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('STUDENTS_AGENT_INFO_TITLE')}
      subtitle={t('STUDENTS_AGENT_INFO_SUBTITLE')}
      icon="zmdi-city-alt"
      size="medium"
    >
      <div className="m-b-20 d-flex align-items-center" style={{ gap: '12px' }}>
        {logoUrl && (
          <img
            src={logoUrl}
            alt={displayName || t('STUDENTS_TABLE_COLUMNS_AGENT')}
            style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: 8, background: '#f7f7f7' }}
          />
        )}
        <div>
          <h5 className="m-b-5">{displayName || t('STUDENTS_TABLE_COLUMNS_AGENT')}</h5>
          <small className="text-muted">{agentEntity.companyName || t('STUDENTS_AGENT_INFO_FIELDS_COMPANY_NAME')}</small>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-md-6">
          {renderInfo(t('STUDENTS_AGENT_INFO_FIELDS_COMPANY_NAME'), agentEntity.companyName || displayName, 'zmdi-city')}
          {renderInfo(
            t('STUDENTS_AGENT_INFO_FIELDS_CONTACT_EMAIL'),
            agentEntity.email || agentEntity?.user?.email,
            'zmdi-email'
          )}
          {renderInfo(
            t('STUDENTS_AGENT_INFO_FIELDS_CONTACT_PHONE'),
            agentEntity.phone || agentEntity?.user?.phone,
            'zmdi-phone'
          )}
          {renderInfo(t('STUDENTS_AGENT_INFO_FIELDS_COUNTRY'), agentEntity.country, 'zmdi-globe')}
          {renderInfo(t('STUDENTS_AGENT_INFO_FIELDS_CITY'), agentEntity.city, 'zmdi-city')}
          {renderInfo(t('STUDENTS_AGENT_INFO_FIELDS_ADDRESS'), agentEntity.address, 'zmdi-pin')}
        </div>
        <div className="col-md-6">
          {renderInfo(
            t('STUDENTS_AGENT_INFO_FIELDS_ASSIGNED_AT'),
            general.formatDate(agentEntity.assignedAt),
            'zmdi-time'
          )}
          {renderInfo(t('STUDENTS_AGENT_INFO_FIELDS_LICENSE_NUMBER'), agentEntity.licenseNumber, 'zmdi-shield-check')}
          {renderInfo(
            t('STUDENTS_AGENT_INFO_FIELDS_LICENSE_EXPIRY_DATE'),
            agentEntity.licenseExpiryDate,
            'zmdi-calendar-alt'
          )}
          {renderInfo(t('STUDENTS_AGENT_INFO_FIELDS_TAX_NUMBER'), agentEntity.taxNumber, 'zmdi-balance')}
          {renderInfo(t('STUDENTS_AGENT_INFO_FIELDS_TAX_OFFICE'), agentEntity.taxOffice, 'zmdi-city-alt')}
          {renderLink(t('STUDENTS_AGENT_INFO_FIELDS_WEBSITE'), agentEntity.websiteUrl, 'zmdi-globe-alt')}
        </div>
      </div>
    </Modal>
  )
}

export default AgentInfoModal


